/**
 * Segmented toggle (Gloss|Lustre, Auto-crop all|Fit all, Crop|Fit, swap
 * actions…). Active segment = white-on-black inversion per the design.
 */

export interface Segment {
  key: string;
  label: string;
  disabled?: boolean;
}

export interface SegmentedProps {
  segments: Segment[];
  /** Active segment key; null = none highlighted (action-style segments). */
  value: string | null;
  onChange: (key: string) => void;
  variant?: 'dark' | 'light' | 'strong';
  ariaLabel: string;
  className?: string;
}

export function Segmented({ segments, value, onChange, variant = 'light', ariaLabel, className }: SegmentedProps) {
  return (
    <div className={`seg seg--${variant}${className ? ` ${className}` : ''}`} role="group" aria-label={ariaLabel}>
      {segments.map((s) => (
        <button
          key={s.key}
          type="button"
          className={`seg__opt${s.key === value ? ' seg__opt--on' : ''}`}
          aria-pressed={s.key === value}
          disabled={s.disabled}
          onClick={() => onChange(s.key)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
